import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IPricingApi } from "@/api/pricing";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { useToast } from "@/hooks/use-toast";
import { invalidatePricing } from "./invalidatePricing";

export const useRemoveMetaRate = () => {
  const pricingApi = useInjection<IPricingApi>(SERVICES_TYPES.PRICING);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) => pricingApi.removeRate(id),
    onSuccess: () => {
      invalidatePricing(queryClient);
      toast({ title: "Rate removed" });
    },
    onError: (error) => {
      toast({ title: "Failed to remove rate", description: error.message, variant: "destructive" });
    }
  });
};
